import {hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedSiteData} from "../../../tracking/algolytics_hits/tracked_utils/tracked_site";
import {CreditAlgolyticsViewType} from "../types/CreditAlgolyticsViewType";

export interface ICreditViewAlgolytics {
    view_type: CreditAlgolyticsViewType;
}

export const CreditViewEvent = (eventPayload: ICreditViewAlgolytics) => {
    const {site_id} = getTrackedSiteData();

    hitAlgolytics("views", {
        site_id,
        ...eventPayload
    });
};
import {hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedSiteData} from "../../../tracking/algolytics_hits/tracked_utils/tracked_site";
import {CreditAlgolyticsViewType} from "../types/CreditAlgolyticsViewType";

export interface ICreditViewAlgolytics {
    view_type: CreditAlgolyticsViewType;
}

export const CreditViewEvent = (eventPayload: ICreditViewAlgolytics) => {
    const {site_id} = getTrackedSiteData();

    hitAlgolytics("views", {
        site_id,
        ...eventPayload
    });
};
